import { render, staticRenderFns } from "./FileThumbnail.vue?vue&type=template&id=c5fcd4a4&scoped=true&"
import script from "./FileThumbnail.vue?vue&type=script&lang=ts&"
export * from "./FileThumbnail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fcd4a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VChip,VImg})
